import { PureComponent } from 'react'
import PropTypes from 'prop-types'


class LastLocationContextProvider extends PureComponent {

  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  static childContextTypes = {
    prevPath: PropTypes.string,
  }

  getChildContext() {
    return {
      prevPath: this.prevPath,
    }
  }

  prevPath = null

  componentWillReceiveProps({ pathname: newPathname }) {
    const { pathname, location } = this.props

    if (!pathname && (location.pathname !== pathname)) {
      this.prevPath = location.pathname
    }
    else if (pathname !== newPathname) {
      this.prevPath = pathname
    }
  }

  render() {
    const { children } = this.props

    return children
  }
}


export default LastLocationContextProvider
